import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-auth-candidate',
  templateUrl: './auth-candidate.component.html',
  styleUrls: ['./auth-candidate.component.css']
})
export class AuthCandidateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// D:/Projects/Empower360Plus/EmpowerWeb2.0/A4.Empower/A4.Empower/ClientApp/src/app/layout/auth-candidate/auth-candidate.component.ts